module.exports = __webpack_public_path__ + "img/play.7f59c2e3.png";